<template>
  <NuxtLayout>
    <LoadingSpinner />
    <NuxtPage />
  </NuxtLayout>
</template>

